import * as types from '../../../constants/actionTypes';

const initialState = {
    detailsFetched: false,
    inprogressFollowUnFollow: false,
    isFollowing: false,
    numberOfFollowers: 0,
};

function startedProgress(state) {
    return {
        ...state,
        inprogressFollowUnFollow: true,
    };
}

function stoppedProgress(state) {
    return {
        ...state,
        inprogressFollowUnFollow: false,
    };
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.FETCH_FOLLOWER_DETAILS:
        case types.FETCH_FOLLOWER_DETAILS_FAIL:
            return {
                ...state,
            };
        case types.FETCH_FOLLOWER_DETAILS_SUCCESS:
            return {
                ...state,
                detailsFetched: true,
                isFollowing: action.result.isFollowing,
                numberOfFollowers: action.result.numberOfFollowers,
            };
        case types.FOLLOW_COMPANY:
            return startedProgress(state);
        case types.FOLLOW_COMPANY_FAIL:
            return stoppedProgress(state);
        case types.FOLLOW_COMPANY_SUCCESS:
            return {
                ...stoppedProgress(state),
                numberOfFollowers: state.numberOfFollowers + 1,
                isFollowing: true,
            };
        case types.UNFOLLOW_COMPANY:
            return startedProgress(state);
        case types.UNFOLLOW_COMPANY_FAIL:
            return stoppedProgress(state);
        case types.UNFOLLOW_COMPANY_SUCCESS:
            return {
                ...stoppedProgress(state),
                numberOfFollowers: state.numberOfFollowers - 1,
                isFollowing: false,
            };
        default:
            return state;
    }
}
